export default __webpack_public_path__ + "static/media/logo.2086ffb1.svg";